import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

import Instructor from '../models/instructor';

class InstructorApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetInstructorsBySchoolId(schoolId: number) {
        const { data } = await this.httpClient.get(`/instructor?schoolId=${schoolId}`);
        return data;
    }

    async AddNewInstructor(instructor: Instructor) {
        const { data } = await this.httpClient.post(`/instructor`, instructor);
        return data;
    }

    async UpdateInstructor(instructor: Instructor) {
        const payload = {
            ...instructor,
        };
        const { data } = await this.httpClient.put(`/instructor`, payload);
        return data;
    }
}

export default InstructorApi;
